import { Company, Price } from "@/features/types";
import { AbstractInvoice } from "@/features/invoices/order-confirmation-invoices/order-confirmation-invoice.type";

/**
 * 부티크 쪽(물품·디파짓을 받는 쪽) 회사인지 — 3자무역이면 3자무역사가 부티크 대신 받는다.
 * 해외(유로) 송금·환율·은행 수수료·영수증 메뉴 등 "받는 쪽 = 부티크" 판단은 이 함수로 한다.
 */
export function isBoutiqueSide(type?: string | null): boolean {
  return type === "BOUTIQUE" || type === "CROSS_TRADER";
}

export class InvoiceUtils {
  static getCurrencyByParties({
    sender,
    receiver,
  }: {
    sender?: Company;
    receiver?: Company;
  }): Price["currency"] {
    if (receiver?.type === "AGENCY") {
      return "KRW";
    } else if (receiver?.type === "BUYER") {
      return "KRW";
    } else {
      return "EUR";
    }
  }

  // 송금영수증 통화 — 연결된 송금 요청이 있으면 그 통화를 따른다(원화 프로포마의 바이어->부티크 송금은
  // 원화다). 연결된 게 없으면 보내는·받는 회사로 정한다.
  static getRemittanceCurrency({
    sender,
    receiver,
    payments,
  }: {
    sender?: Company;
    receiver?: Company;
    payments?: { amount?: { currency?: string } | null }[];
  }): Price["currency"] {
    const paymentCurrency = payments?.find((payment) => payment.amount?.currency)
      ?.amount?.currency;
    if (paymentCurrency === "KRW" || paymentCurrency === "EUR") {
      return paymentCurrency;
    }
    return InvoiceUtils.getCurrencyByParties({ sender, receiver });
  }

  static getPaidByParties({
    sender,
    receiver,
  }: {
    sender?: Company;
    receiver?: Company;
  }): AbstractInvoice["paidBy"] | undefined {
    if (sender && receiver) {
      if (sender.type === "BUYER" && isBoutiqueSide(receiver.type)) {
        return "BUYER";
      } else {
        return "AGENCY";
      }
    }
    return undefined;
  }
}
